import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type cancelCompanyDataType = {
  successCallback: Function;
  errorCallback: Function;
  resultKey: string;
};

export default ({ successCallback, errorCallback, resultKey = 'cancelImportedDataResponse' }: cancelCompanyDataType) =>
  requestAsync({
    url: endpoints.getCancelImportedDataUrl(),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getCancelImportedDataUrl(),
    body: {},
    options: {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
